import React from 'react';
import { Leaf, TreePine, Recycle, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();
  
  const environmental = [
    {
      icon: TreePine,
      titleKey: 'services.forestManagement.title',
      descriptionKey: 'services.forestManagement.description',
      featuresKeys: [
        'services.forestManagement.feature1',
        'services.forestManagement.feature2',
        'services.forestManagement.feature3'
      ]
    },
    {
      icon: Leaf,
      titleKey: 'services.co2Capture.title',
      descriptionKey: 'services.co2Capture.description',
      featuresKeys: [
        'services.co2Capture.feature1',
        'services.co2Capture.feature2',
        'services.co2Capture.feature3'
      ]
    },
    {
      icon: Globe,
      titleKey: 'services.origin.title',
      descriptionKey: 'services.origin.description',
      featuresKeys: [
        'services.origin.feature1',
        'services.origin.feature2',
        'services.origin.feature3'
      ]
    },
    {
      icon: Recycle,
      titleKey: 'services.naturalProduct.title',
      descriptionKey: 'services.naturalProduct.description',
      featuresKeys: [
        'services.naturalProduct.feature1',
        'services.naturalProduct.feature2',
        'services.naturalProduct.feature3'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-cmv-green font-semibold text-sm uppercase tracking-wider">
            {t('services.label')}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {environmental.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              >
                <div className="w-16 h-16 bg-cmv-green/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-cmv-green group-hover:scale-110 transition-all duration-300">
                  <Icon className="text-cmv-green group-hover:text-white transition-colors" size={32} />
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {t(item.titleKey)}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {t(item.descriptionKey)}
                </p>

                <ul className="space-y-2">
                  {item.featuresKeys.map((featureKey, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <div className="w-1.5 h-1.5 bg-cmv-green rounded-full mr-3"></div>
                      {t(featureKey)}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
